import { Tooltip } from '@odo/shared-ui';
import { UserAvatar } from './UserAvatar';

interface UserCellProps {
    name: string;
    email: string;
    size?: number;
}

export function UserCell({ name, email, size = 36 }: UserCellProps) {
    // One tooltip over the text block carrying both lines (the Tooltip
    // renders '\n' as a line break) - either line can truncate, and a single
    // reveal beats two stacked ones a few pixels apart. Lives here, not in a
    // column's `getTitle`: UserCell also renders outside tables
    // (ExistingUserPane), and the reveal must travel with it.
    return (
        <div className="flex items-center gap-3 min-w-0">
            <UserAvatar name={name} size={size} />
            <Tooltip content={`${name}\n${email}`}>
                <div className="min-w-0">
                    <span className="block text-sm font-semibold text-gray-900 truncate">
                        {name}
                    </span>
                    <span className="block text-[12px] text-gray-500 truncate">{email}</span>
                </div>
            </Tooltip>
        </div>
    );
}
